import { useState, useEffect } from "react";
// Build own carousel=props:slides(link/title/desc)/effect/timer/duration/size - with a transition effect (fade in is nice) - timer to iterate slides into state var which will update DOM

import "./carousel.css";

const SliderCarousel = ({ slides, options, styles, MODE }) => {
   //slides =  [ [ "url", "detail1", "detail2" ], ...] 
   options = { //* setting defaults!
      // size: options.size || "auto", // image height
      // many: options.many || 3, // show how many
      // effect: options.effect || "fade", //
      // timer: options.timer || 3000, // stop after ...
      // direction: options.direction || "+", // + fwd, - rev
      // duration: options.duration || 1000, // effect-timing
      interval: options.interval || 4500, // progression
      // loop: options.loop || 0, // repetition (0 ∞)    
   };

   styles = { //* setting defaults!      
   };

   const [currSlide, setCurrSlide] = useState(!slides ? null : 0);
   // const prevSlide = (s) => { return s === 0 ? slides.length - 1 : s - 1 };
   const nextSlide = (s) => { return s === slides.length - 1 ? 0 : s + 1 };
   //[prev,curr,next] assumes atleast 3 //todo scenario = <3 slides? 
   const slidesStrip = (s) => {
      return (
         <>
            {/* <div className="previous">
               <img src={slides[prevSlide(s)][0]} alt={slides[prevSlide(s)][2]} />
            </div> */}

            <div className="main"
               key={slides[s][0]} //triggers animations
            >
               <img
                  src={slides[s][0]}
                  title={`${slides[s][1]} ${MODE === "Dev" ? "300x400" : ""}`}
                  alt={slides[s][2]}
                  key={slides[s][0]} //triggers animations
               >
               </img>
               <div className="detail1">
                  {slides[s][1]}
               </div>
               <div className="detail2">
                  {slides[s][2]}
               </div>

            </div >

            {/* <div className="next">
               <img src={slides[nextSlide(s)][0]} alt={slides[nextSlide(s)][2]} />
            </div> */}

         </>
      )
   };

   const [carousel, setCarousel] = useState(slidesStrip(currSlide));

   const refresh = () => {
      setCurrSlide(nextSlide(currSlide));
      setCarousel(slidesStrip(currSlide));
   }

   useEffect(() => {
      const interval =
         setTimeout(
            refresh,
            options.interval * 1 //! adjust for "testing"
         );
      return () => {
         clearTimeout(interval);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currSlide])


   return (

      <div className="frame">
         {carousel}
      </div>

   )
}

export default SliderCarousel;
